import React from "react";
import { Container, Heading, SubHeading,Logo,Text,InfoContainer,Frame,Pane,Line} from "./styles/usedBy";

export default function UsedBy({ children, ...restProps }) {
  return <Container {...restProps}> {children} </Container>;
}

UsedBy.Heading = function UsedByHeading({ children, ...restProps }) {
  return <Heading {...restProps}>{children}</Heading>;
};

UsedBy.SubHeading = function UsedBySubHeading({ children, ...restProps }) {
  return <SubHeading {...restProps}>{children}</SubHeading>;
};

UsedBy.Logo = function UsedByLogo({children, ...restProps}){
  return <Logo {...restProps} />
}

UsedBy.Text = function UsedByText({children, ...restProps}){
  return <Text {...restProps}>{children}</Text>
}

UsedBy.InfoContainer = function UsedByInfoContainer({children, ...restProps}){
  return <InfoContainer {...restProps}>{children}</InfoContainer>
}

UsedBy.Frame = function UsedByFrame({children, ...restProps}){
  return <Frame {...restProps}>{children}</Frame>
}

UsedBy.Pane = function UsedByPane({children, ...restProps}){
  return <Pane {...restProps}>{children}</Pane>
}

UsedBy.Line = function UsedByLine({children, ...restProps}){
  return <Line {...restProps}>{children}</Line>
}